/// <amd-module name="SuiteCommerce.Blog.Pagination.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.Pagination.View", ["require", "exports", "Backbone", "sc_blog_pagination.tpl", "Backbone.CollectionView", "SuiteCommerce.Blog.Pagination.Button.View", "SuiteCommerce.Blog.Pagination.Button.Model", "SuiteCommerce.Blog.Pagination.Button.Collection"], function (require, exports, Backbone_1, paginationTemplate, BackboneCollectionView, Pagination_Button_View_1, Pagination_Button_Model_1, Pagination_Button_Collection_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.PaginationView = void 0;
    var PaginationView = /** @class */ (function (_super) {
        __extends(PaginationView, _super);
        function PaginationView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = paginationTemplate;
            _this.model.on('change:visibleButtonGroup', function () {
                _this.render();
            });
            return _this;
        }
        Object.defineProperty(PaginationView.prototype, "childViews", {
            get: function () {
                var _this = this;
                return {
                    'Pagination.Buttons.View': function () {
                        return new BackboneCollectionView({
                            childView: Pagination_Button_View_1.PaginationButtonView,
                            collection: _this.model.visibleButtonGroup,
                            childViewOptions: {
                                isEnabledEventsHandling: _this.model.isEnabledEventsHandling,
                                paginationEventId: _this.model.paginationEventId,
                            },
                        });
                    },
                };
            },
            enumerable: false,
            configurable: true
        });
        PaginationView.prototype.generateButtons = function () {
            var _this = this;
            var buttons = new Pagination_Button_Collection_1.PaginationButtonCollection();
            if (this.model.total > this.model.pageSize) {
                var quantityOfPages = Math.ceil(this.model.total / this.model.pageSize);
                for (var i = 1; i <= quantityOfPages; i += 1) {
                    buttons.add(new Pagination_Button_Model_1.PaginationButtonModel({
                        pageNumber: i,
                        isActive: this.model.currentPage === i,
                        isEnabledEventsHandling: this.model.isEnabledEventsHandling,
                    }));
                }
            }
            this.model.buttons = buttons;
            this.model.visibleButtonGroup.on(this.model.paginationEventId, function (data) {
                _this.trigger(_this.model.paginationEventId, data);
            });
        };
        PaginationView.prototype.getContext = function () {
            return {
                paginationLabel: this.model.paginationLabel,
                showPagination: this.model.buttons && this.model.buttons.size() > 0,
            };
        };
        return PaginationView;
    }(Backbone_1.View));
    exports.PaginationView = PaginationView;
});
